import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useBrandSettings = defineStore('brand-settings', () => {
    const socials = ref([]);

    const addSocial = (platform, url) => {
        socials.value.push({
            platform,
            url,
        });
    };

    return {
        socials,
        addSocial,
    };
});
